<template>
  <Popup
    :width="width"
    :margin="margin"
    :radiusType="radiusType"
    :closePopupEvent="closePopup"
  >
    <div class="content-share" slot="component">
      <div>
        <p class="content-share-link-title">{{ $t("share this link") }}</p>
        <p class="Clipboard" v-if="copiedText">copied</p>
        <p class="content-share-">
          {{ $t("Watch") }} "{{ content.title }}" {{ $t("on Ultra Play") }}!

        </p>
        <div class="content-share-input" dir="ltr">
          <input
            class="content-share-input-link-field"
            id="content-share-link"
            type="text"
            @keydown.prevent
            v-model="link"
            ref="link"
          />
          <button
            @click="copyText"
            class="content-share-input-btn-copy copy-btn primary-nammaflix-button"
            :data-clipboard-text="link"
          >
            {{ $t("copy") }}
          </button>
        </div>
      </div>
      <!-- <p class="content-share-title">Share to</p> -->
      <div>
        <ul class="content-share-list">
          <li>
            <a :href="'https://www.facebook.com/share.php?u=' + link" target="_blank">
            <img
              src="@/assets/icons/newfb.svg"
              class="share-ico"
              alt="fb icon"
            />
          </a>
          </li>

         

          <li>
            <a target="_blank" :href="'http://twitter.com/share?url=' + link">
            <img
              src="@/assets/icons/newtwitter.svg"
              class="share-ico"
              alt="gp icon"
            />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </Popup>
</template>

<script>
import snackbar from "node-snackbar";
import "../../../node_modules/node-snackbar/dist/snackbar.css";
import ClipboardJS from "clipboard";
import googleAnalytics from "@/mixins/googleAnalytics.js";
import cleverTap from "@/mixins/clevertap.js";
import common from "@/mixins/common.js";
import { mapGetters } from "vuex";
import { _providerId, _projectName } from "@/provider-config.js";
import { eventBus } from "@/eventBus";
import Utility from "@/mixins/Utility.js";

import { showSnackBar } from "@/utilities";
import content from "../../store/Modules/Content/content";

export default {
  props: {
    closePopup: {
      type: Function,
    },
    content: {
      type: Object,
    },
  },
  data() {
    return {
      width: "30%",
      margin: "10% auto",
      radiusType: "full",
      link: null,
      clipboard: undefined,
      localDisplayLang: "",
      copiedText: false,
    };
  },
  computed: {
    ...mapGetters(["availabilityList"]),
  },
  created() {
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    //checking for change of language in local storage value
    eventBus.$on("check-local-storage", (data) => {
      this.localDisplayLang = data;
    });
    //assigning availability list response.
  },

  mounted() {
    setTimeout(() => {
      this.$refs.link.disabled = true;

      let dom = document.getElementById("popup-close-icon");
      dom.style.opacity = 1;
    }, 100);
    this.createLink("sharing");
    let item = this.content;
    let mediaType = "";
    let title
    if (item.category == "TVSHOW") {
      if (this.localDisplayLang == "eng") {
        title = this.spacialCharEncoding(item.title);
      } else {
        title = "title";
      }
      mediaType = "/series/";
    } else {
      if (this.localDisplayLang == "eng") {
        title = this.spacialCharEncoding(item.title);
      } else {
        title = "title";
      }
      mediaType = "/movie/";
    }
    let urlData = mediaType + title + "/" + item.objectid;
    console.error("urlData", urlData);
    this.link = location.origin + `${urlData}`;

  },
  methods: {
    copyText() {
      this.copiedText = true;
      setTimeout(() => {
        this.copiedText = false;
      }, 2000);

      var copyText = document.getElementById("content-share-link");

      // Select the text field
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.value);
    },

    createLink(medium) {
      console.log("what is the route in share content", this.$route);
      let self = this;

      var linkData = {
        // branch_key: "key_live_ndGW8YRJAehKig50HTghTcooDsdLBpj3",
        campaign: "content",
        channel: medium,
        stage: "new user",
        alias: "",
        data: {
          custom_bool: true,
          custom_int: Date.now(),
          custom_string: "Deep Link",
          $canonical_identifier: this.content.objectid,
          $og_title: this.content.title,
          $og_description: this.content.shortdescription,
          //$og_image_url: this.getPoster(this.content),
          $desktop_url: "https://noorplay.com",
          // $desktop_url: "https://netfive-web.web.app",
          // $desktop_url: "https://net5.in",
          $ios_deeplink_path: `net5://content/details/${this.content.objectid}`,
          $android_deeplink_path: `net5://content/details/${this.content.objectid}`,
          $desktop_deeplink_path: `${window.location.origin}/content/details/${this.content.objectid}`,
        },
      };

      branch?.link(linkData, function(err, link) {
        let item = self.content;
        let mediaType = "";
        let title
        if (item.category == "TVSHOW") {
          if (self.localDisplayLang == "eng") {
            title = this.spacialCharEncoding(item.title);
          } else {
            title = "title";
          }
          mediaType = "/series/";
        } else {
          if (self.localDisplayLang == "eng") {
            title = this.spacialCharEncoding(item.title);
          } else {
            title = "title";
          }
          mediaType = "/movie/";
        }

        let urlData = mediaType + title + "/" + item.objectid;

        link = location.origin + `${urlData}`;
        self.link = link;

        // self.createLink();
        // self.initTwitterUrl();
      });
    },
  },
  components: {
    Popup: () =>
      import(/* webpackChunkName: "Popup" */ "@/components/Slots/Popup.vue"),
  },
  mixins: [googleAnalytics, cleverTap, common, Utility],
};
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";
@import "./contentShare.scss"

</style>
